import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface NoDiagnosticsQuoteDialogProps {
  open: boolean;
  /** "No" — abort the quote and prompt the tech to post a Diagnostics note. */
  onCancel: () => void;
  /** "Yes" — create the quote anyway. */
  onContinue: () => void;
}

/**
 * Confirmation shown when the tech adds a quote to a Work Item that has no
 * Diagnostics job-log. Quote descriptions are seeded from the latest
 * Diagnostics entry, so we nudge the tech to post one first. Shared by the
 * default expansion panel and the technician-card panel.
 */
export const NoDiagnosticsQuoteDialog: React.FC<NoDiagnosticsQuoteDialogProps> = ({
  open,
  onCancel,
  onContinue,
}) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle>No Diagnostics Comment</DialogTitle>
    <DialogContent>
      <DialogContentText>
        No diagnostics comment has been posted to this Work Item — Continue anyway?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>No</Button>
      <Button onClick={onContinue} variant="contained" autoFocus>
        Yes
      </Button>
    </DialogActions>
  </Dialog>
);
